import type { components } from '@/generated/contracts/api-v1';
import { fieldMap, type FieldSpec, type LegacyRow } from './fieldMap';

// org_instances table; OrgReadService (lureo-backend Data/Api/V1/Orgs/OrgReadService.cs) builds OrgDto
export type OrgDto = components['schemas']['OrgDto'];

const spec = {
  uniqueId: 'org_instance_id',
  displayName: 'org_instance_display_name',
  sourceName: 'org_instance_source_name',
  orgTypeUniqueId: 'org_type_id',
  subscriptionPlan: 'org_instance_subscription_plan',
  subscriptionStatus: 'org_instance_subscription_status',
  billingCycle: 'org_instance_billing_cycle',
  nextBillingDate: 'org_instance_next_billing_date',
  // The generic route's computed OrgInstanceImmersalConfigured property
  immersalConfigured: 'org_instance_immersal_configured',
  createdAt: 'created_at',
} as const satisfies FieldSpec<OrgDto>;

const map = fieldMap<OrgDto, typeof spec>('Org', spec);

export type LegacyOrg = LegacyRow<typeof spec, OrgDto>;

export const orgToLegacy = (dto: OrgDto): LegacyOrg => map.toLegacy(dto);
